import React, { useEffect } from 'react'
import { Button, Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../components/Loader'
import Message from '../components/Message'
import Paginate from '../components/Paginate'
import { listPosts, deletePost } from '../actions/mediaActions'
import { Helmet } from 'react-helmet-async'

function PostListScreen({ history }) {

  const dispatch = useDispatch()

  const postList = useSelector(state => state.postList)
  const { loading, error, posts, page, pages } = postList

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  const postDelete = useSelector(state => state.postDelete)
  const { success: successDelete } = postDelete

  let keyword = history.location.search

  useEffect(() => {
    if (!userInfo || !userInfo.isAdmin) {
      history.push('/login')
    } else {
      dispatch(listPosts(keyword))
    }
  }, [dispatch, history, userInfo, successDelete, keyword])

  const deleteHandler = (id) => {
    if (window.confirm('Sei sicuro di voler eliminare questo post?')) {
      dispatch(deletePost(id))
    }
  }

  return (
    <div>
      <Helmet>
       <meta name="robots" content="noindex, follow" />
      </Helmet>
      <h1>Post</h1>

      {loading ? <Loader />
        : error ? <Message variant='danger'>{error}</Message>
        :
        <div>
          <Table striped bordered hover responsive className='table-sm'>
            <thead>
              <tr>
                <th>Titolo</th>
                <th>Autore</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {posts.map(post => (
                <tr key={post._id}>
                  <td style={{maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                    {post.name && post.name.length > 60 ? post.name.slice(0, 60) + '…' : post.name}
                  </td>
                  <td>{post.username}</td>
                  <td>
                    <Button variant='danger' className='btn-sm' onClick={() => deleteHandler(post._id)}>
                      <i className='fas fa-trash'></i> Elimina
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <Paginate page={page} pages={pages} keyword={keyword} basePath="/admin/postlist"/>
        </div>
      }
    </div>
  )
}

export default PostListScreen